import { suiGraphQlUrl } from '@/config/sui';

const COIN_DECIMALS_QUERY = `
  query CoinDecimals($coinType: String!) {
    coinMetadata(coinType: $coinType) {
      decimals
    }
  }
`;

interface CoinDecimalsGraphQlResponse {
  data?: { coinMetadata: { decimals: number | null } | null };
  errors?: { message: string }[];
}

export async function getCoinDecimals(coinType: string): Promise<number | null> {
  const response = await fetch(suiGraphQlUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query: COIN_DECIMALS_QUERY, variables: { coinType } }),
  });

  if (!response.ok) {
    throw new Error(`Sui GraphQL request failed with status ${response.status}`);
  }

  const body = (await response.json()) as CoinDecimalsGraphQlResponse;
  if (body.errors?.length) {
    throw new Error(`Sui GraphQL request failed: ${body.errors[0]!.message}`);
  }

  return body.data?.coinMetadata?.decimals ?? null;
}
